import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { Slot } from "radix-ui";
import { cn } from "./cn";
const buttonVariants = cva("inline-flex shrink-0 items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground hover:bg-primary/90",
      destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:bg-destructive/60 dark:focus-visible:ring-destructive/40",
      outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
      secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
      ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
      link: "text-primary underline-offset-4 hover:underline",
      "osmix-filled": "bg-osmix-tangelo text-white type-button hover:bg-osmix-tangelo/90",
      "osmix-dark": "bg-osmix-dark text-white type-button hover:bg-osmix-dark/90",
      "osmix-outline": "border border-osmix-gray-300 bg-white text-osmix-text-1 type-button hover:border-osmix-text-1",
      "osmix-link": "type-body2 text-osmix-tangelo hover:underline border-0 bg-transparent"
    },
    size: {
      default: "h-9 px-4 py-2 has-[>svg]:px-3",
      xs: "h-6 gap-1 rounded-md px-2 text-xs has-[>svg]:px-1.5 [&_svg:not([class*='size-'])]:size-3",
      sm: "h-8 gap-1.5 rounded-md px-3 has-[>svg]:px-2.5",
      lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
      icon: "size-9",
      "icon-xs": "size-6 rounded-md [&_svg:not([class*='size-'])]:size-3",
      "icon-sm": "size-8",
      "icon-lg": "size-10",
      pill: "h-10 gap-1.5 rounded-[24px] px-6",
      "pill-sm": "h-8 gap-1.5 rounded-[24px] px-3",
      inline: "h-auto gap-1 px-0"
    }
  },
  compoundVariants: [{
    variant: "osmix-outline",
    size: "pill",
    className: "px-4"
  }],
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
function Button(t0) {
  const $ = _c(16);
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      size: t2,
      asChild: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const variant = t1 === undefined ? "default" : t1;
  const size = t2 === undefined ? "default" : t2;
  const asChild = t3 === undefined ? false : t3;
  const Comp = asChild ? Slot.Root : "button";
  let t4;
  if ($[6] !== className || $[7] !== size || $[8] !== variant) {
    t4 = cn(buttonVariants({
      variant,
      size,
      className
    }));
    $[6] = className;
    $[7] = size;
    $[8] = variant;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== Comp || $[11] !== props || $[12] !== size || $[13] !== t4 || $[14] !== variant) {
    t5 = <Comp data-slot="button" data-variant={variant} data-size={size} className={t4} {...props} />;
    $[10] = Comp;
    $[11] = props;
    $[12] = size;
    $[13] = t4;
    $[14] = variant;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
export { Button, buttonVariants };